export const columns = function () {
  return [
    {
      prop: 'id',
      label: 'ID',
      minWidth: 20
    },
    {
      prop: 'name',
      label: '项目名称',
      minWidth: 50
    },
    {
      prop: 'money',
      label: '基础金额',
      minWidth: 100,
    },
    {
      prop: 'status',
      label: '状态',
      minWidth: 50,
    },
    {
      prop: 'createtime',
      label: '创建时间',
      minWidth: 80,
    },
    {
      prop: "handle",
      label: "操作",
      minWidth: 50,
    },
  ]
}


export default {}